import { useState } from "react";
import Modal from 'react-modal';
import MgpButton from "../../elements/MgpButton/MgpButton";
import { SUBSCRIPTION_ERROR_MESSAGE } from "../../const/AppConst";

type MessageModalProps = {
    type: "success" | "danger" | "info" | "warning" | "general";
    message: string;
    closeAction?: () => void;
  };
  
  
  
  export default function SubscriptionMessageModal({
    type,
    message, 
    closeAction
  }: MessageModalProps) {
    const [modalIsOpen, setIsOpen] = useState(true);
    Modal.setAppElement("#root");


    function closeModal() {
        setIsOpen(false);
        if(closeAction) {
          closeAction();
        }
    }

    const isAffiliatedWithAcc = message === SUBSCRIPTION_ERROR_MESSAGE.AFFILIATED_WITH_ACCOUNT;

    const handleRedirect = () => {
        const url = process.env.REACT_APP_ADHERENT_BASE_URL ?? "https://adherent.mgp.fr/connexion";
        window.open(url, "_blank");
    };


    return (
        <Modal isOpen={modalIsOpen}>
            <div className="modale open">  
                
                <div className="modale--content">
                
                    <div className="modale--main-width-entreprise p-lg m-y-xl bg-blanc ta-center">  
                        <span
                            className="close-modale-button"
                            onClick={closeModal}
                        >
                            <i className="blanc fz-xl">×</i>
                        </span>
                           
                        <div className={"grid-flex va-center m-y-lg"} style={{flexWrap: "nowrap", textAlign: "left"}}>
                            <span dangerouslySetInnerHTML={{__html: message}} style={{maxWidth: "100%", whiteSpace: 'pre-line'}}></span>
                        </div>       
                        
                        {
                            isAffiliatedWithAcc &&
                            <div className="wrapper-cta-inline mt-xl">
                                <MgpButton color="bleu" size="small" onClick={handleRedirect} text="Me connecter" />
                            </div>    
                        }            
                    </div>
                </div>
            </div>
        </Modal>
    );
  }